import * as types from "./types";

export const fetchingAgreements = () => ({
  type: types.FETCHING_AGREEMENTS,
  loading: true
});
 

export const fetchedAgreements=(agreements)=>({
  type: types.FETCHED_AGREEMENTS,
  agreements: agreements,
  loading: false
});

export const errorFetchingAgreements = (error) => ({
  type: types.ERROR_FETCHING_AGREEMENTS,
  error: error,
  loading: false
});

 